import { useFormikContext } from 'formik';
import { useEffect, useState } from 'react';

import styled from '@emotion/styled';

import CheckboxIcon from '../Icons/CheckboxIcon';

interface PasswordStrengthViewerProps {
  passwordName: string;
}

interface defaultPasswordStateInterface {
  asLengthAtLeast8: boolean;
  asUppercase: boolean;
  asLowercase: boolean;
  asNumber: boolean;
  asSpecialChar: boolean;
}

const defaultPasswordState: defaultPasswordStateInterface = {
  asLengthAtLeast8: false,
  asUppercase: false,
  asLowercase: false,
  asNumber: false,
  asSpecialChar: false,
};

export const PasswordStrengthViewer: React.FC<PasswordStrengthViewerProps> = ({
  passwordName,
}) => {
  const { values } = useFormikContext<any>();
  const [strengthClass, setStrengthClass] =
    useState<defaultPasswordStateInterface>(defaultPasswordState);

  useEffect(() => {
    const strengthLevel = {
      ...defaultPasswordState,
    };
    const password = values[passwordName];
    if (/[a-z]/.test(password)) strengthLevel.asLowercase = true;
    if (/[A-Z]/.test(password)) strengthLevel.asUppercase = true;
    if (/[0-9]/.test(password)) strengthLevel.asNumber = true;
    if (/[@$!%*?&]/.test(password)) strengthLevel.asSpecialChar = true;
    if (password.length > 7) strengthLevel.asLengthAtLeast8 = true;

    setStrengthClass(strengthLevel);
    // eslint-disable-next-line
  }, [values]);

  return (
    <Container>
      <div>
        {strengthClass.asLengthAtLeast8 ? <CheckboxIcon /> : <HollowBox />}
        Password must be 8 characters long.
      </div>
      <div>
        {strengthClass.asUppercase ? <CheckboxIcon /> : <HollowBox />}
        Password must have a capital letter.
      </div>
      <div>
        {strengthClass.asSpecialChar ? <CheckboxIcon /> : <HollowBox />}
        Password must have a special character.
      </div>
      <div>
        {strengthClass.asNumber ? <CheckboxIcon /> : <HollowBox />}
        Password must have a number.
      </div>
      <div>
        {strengthClass.asLowercase ? <CheckboxIcon /> : <HollowBox />}
        Password must have a small letter.
      </div>
      {/* <div>
        {strengthClass.asConfirmPassword ? <CheckboxIcon /> : <HollowBox />}
        Confirm password match.
      </div> */}
    </Container>
  );
};

export default PasswordStrengthViewer;

const Container = styled.div`
  flex-direction: column;
  display: flex;
  gap: 8px;
  flex-direction: column;

  & > * {
    color: ${({ theme }) => theme.palette.grayTextColor};
    font-size: 14px;
    line-height: 20px;
    display: flex;
    gap: 10px;
  }
`;

const HollowBox = styled.div`
  display: flex;
  border: 1px solid #6b7280;
  width: 19px;
  height: 18px;
  border-radius: 6px;
  margin-top: 1px;
  margin-left: 1px;
`;
